import { ReactNode } from "react"

import { Box, Button, Tooltip, Typography } from "@mui/material"
import { IStudentSideTransactionsAll } from "api/reactQuery/queries/studentTransactionsAll.type"
import ErrorText from "components/common/error/errorText"
import BasicItem from "components/common/listing/basicItem"
import { useTranslation } from "react-i18next"
import { CSSTransition, TransitionGroup } from "react-transition-group"
import { PrimaryTile } from "styles/common/tile"

interface IProps {
  header?: ReactNode
  footer?: ReactNode
  handleTransactionClick: (transaction: IStudentSideTransactionsAll) => void
  data: IStudentSideTransactionsAll[] | []
  isError: boolean
  showTooltip?: boolean
}

const PendingTransactionsList = ({
  header,
  footer,
  handleTransactionClick,
  data,
  isError,
  showTooltip,
}: IProps) => {
  const { t } = useTranslation()

  return (
    <PrimaryTile overflow="hidden">
      {header}
      <TransitionGroup component={null}>
        {isError ? (
          <ErrorText />
        ) : (
          data?.map((transaction, index) => (
            <CSSTransition
              key={transaction.id}
              classNames="animation-fade"
              timeout={700}
              unmountOnExit
            >
              <BasicItem
                topTextTitle={t("dashboardStudent.class")}
                topText={transaction.class.name}
                bottomTextTitle={t("dashboardStudent.title")}
                bottomText={transaction.title}
                actionButtonsSlot={
                  <Box
                    pl="16px"
                    borderLeft={(theme) =>
                      `1px solid ${theme.palette.mockup.primary95}`
                    }
                  >
                    <Tooltip
                      title={
                        <Typography variant="body3">
                          {t("dashboardStudent.clickToProcessTransaction")}
                        </Typography>
                      }
                      open={showTooltip && index === 0}
                      arrow
                      placement="top-end"
                      PopperProps={{
                        style: {
                          maxWidth: "150px",
                          width: "auto",
                          textAlign: "center",
                        },
                      }}
                    >
                      <Button
                        variant="outlined"
                        sx={(theme) => ({
                          padding: "8px 22px",
                          ...(showTooltip &&
                            index === 0 && {
                              border: `2px solid ${theme.palette.primary.main}`,
                              borderColor: theme.palette.primary.main,
                              boxShadow: `0 0 10px ${theme.palette.primary.main}40`,
                            }),
                        })}
                        className={
                          showTooltip && index === 0 ? "button-pulse" : ""
                        }
                        onClick={() => {
                          handleTransactionClick(transaction)
                        }}
                      >
                        {transaction.type === "bonus" ||
                        transaction.type === "salary"
                          ? t("dashboardStudent.deposit")
                          : t("dashboardStudent.withdraw")}
                      </Button>
                    </Tooltip>
                  </Box>
                }
              />
            </CSSTransition>
          ))
        )}
      </TransitionGroup>
      {footer}
    </PrimaryTile>
  )
}

export default PendingTransactionsList
